<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit.prevent="passes(submitForm)">
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Contact First Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="contactFirstName" aria-label="Contact first name" required />
        </d-field>
        <d-field label="Contact Last Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="contactLastName" aria-label="Contact last name" required />
        </d-field>
      </div>

      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Company Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="companyName" aria-label="Company name" placeholder="Legal Company Name" required />
        </d-field>
        <d-field label="Phone" class="w-full md:w-1/2 px-5">
          <d-input v-model="contactPhone" aria-label="Contact Phone number" placeholder="Phone Number with Area Code" required />
        </d-field>
        <d-field label="Fax" class="w-full md:w-1/2 px-5">
          <d-input v-model="contactFax" aria-label="Fax Number" placeholder="Fax Number with Area Code" />
        </d-field>
        <d-field label="Email" class="w-full md:w-1/2 px-5">
          <d-input v-model="contactEmail" aria-label="Contact email" type="email" placholder="Primary Contact's Email Address" required />
        </d-field>
      </div>


      <d-field label="Contact's Role (check all that apply)">
        <div>
          <div>
            <d-checkbox v-model="contactRole" native-value="Designer">
              Designer
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="contactRole" native-value="General Contractor">
              General Contractor
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="contactRole" native-value="Woodwork Subcontractor">
              Woodwork Subcontractor
            </d-checkbox>
          </div>
        </div>
      </d-field>

      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Project Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="projectName" aria-label="Project name" required />
        </d-field>
        <d-field label="QCP Project Number" class="w-full md:w-1/2 px-5">
          <d-input v-model="qcpProjectNumber" aria-label="Project Number" required />
        </d-field>
      </div>


      <d-field label="Inspection Type (check all that apply)">
        <div>
          <div>
            <d-checkbox v-model="inspectionType" native-value="Full Project Inspection">
              Full Project Inspection
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="inspectionType" native-value="Shop Drawing Review Only">
              Shop Drawing Review Only
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="inspectionType" native-value="Physical Inspection">
              Physical Inspection
            </d-checkbox>
          </div>          
          <div>
            <d-checkbox v-model="inspectionType" native-value="Video Inspection">
              Video Inspection
            </d-checkbox>
          </div>
        </div>
      </d-field>

      <d-field label="Reason for Request" class="w-full ">
        <d-input v-model="requestReason" aria-label="Reason for request" type="textarea" placeholder="Enter any comments or notes" />
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn type="submit" class="mx-5 md:mx-0" :loading="submitting">
          Submit
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { REQUEST_INSPECTION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions, mapState } = createNamespacedHelpers('requestInspectionForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['contactFirstName', 'contactLastName', 'companyName', 'contactPhone', 'contactFax', 'contactEmail', 'contactRole', 'projectName', 'qcpProjectNumber', 'inspectionType', 'requestReason'],
        module: 'requestInspectionForm',
        base: 'formFields',
        mutation: REQUEST_INSPECTION_FORM.FORM_FIELDS,
      }),
      ...mapState([
        'submitting',
      ]),
    },

    methods: {
      ...mapActions([
        'submitForm',
      ]),
    },
  };
</script>